import {
  FETCH_VERIFICATIONS,
  FETCH_VERIFICATIONS_DETAILS,
  UPDATE_VERIFICATIONS_DETAILS,
} from './actionTypes';
import parseError from 'utils/parseError';
import { mapKeys } from 'lodash';

const INITIAL_STATE = {
  data: {},
  meta: {},
  fetching: false,
  editing: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_VERIFICATIONS.pending:
    case FETCH_VERIFICATIONS_DETAILS.pending:
      return {
        ...state,
        fetching: true,
        error: null,
      };

    case FETCH_VERIFICATIONS.rejected:
    case FETCH_VERIFICATIONS_DETAILS.rejected:
      return {
        ...state,
        fetching: false,
        error: parseError(action.payload),
      };

    case FETCH_VERIFICATIONS.fulfilled:
      return {
        ...state,
        fetching: false,
        data: mapKeys(action.payload.data.Documents, '_id'),
        meta: action.payload.data.Paginate,
      };

    case FETCH_VERIFICATIONS_DETAILS.fulfilled:
      return {
        ...state,
        fetching: false,
        data: {
          ...state.data,
          [action.payload.data._id]: action.payload.data,
        },
      };

    case UPDATE_VERIFICATIONS_DETAILS.pending:
      return {
        ...state,
        editing: true,
      };

    case UPDATE_VERIFICATIONS_DETAILS.rejected:
      return {
        ...state,
        editing: false,
      };

    case UPDATE_VERIFICATIONS_DETAILS.fulfilled:
      return {
        ...state,
        editing: false,
      };

    default:
      return state;
  }
};
